module.exports = __webpack_public_path__ + "img/tourism.ea5b7427.svg";